/**
 * Supabase rejects requests with plain objects, not Error instances, so an
 * `instanceof Error` check alone hides the database's own explanation. Billing and
 * payroll rules rely on those messages telling the user exactly what to correct.
 */
export function getActionErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) return error.message;

  if (error && typeof error === 'object') {
    const { message, details, hint } = error as Record<string, unknown>;
    const primary = [message, details, hint].find(
      (value): value is string => typeof value === 'string' && value.trim().length > 0,
    );
    if (primary) return primary;
  }

  if (typeof error === 'string' && error.trim()) return error;
  return fallback;
}
